"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  CursorChoose1: ['cursor-choose-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.711,18.71l-5.1-5.1a2.277,2.277,0,1,1,3.221-3.22l3.245,3.244,6.076-8.1a2.277,2.277,0,0,1,3.643,2.733l-7.652,10.2A2.276,2.276,0,0,1,11.711,18.71Z', 'M11.705,8.537l2.253-3.006a2.28,2.28,0,0,1,2.449-.823', 'M8.891,19.246a2.277,2.277,0,0,1-2.373-.536l-5.1-5.1A2.277,2.277,0,0,1,3.782,9.85']],
  CheckCircle1: ['check-circle-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6,13.223,8.45,16.7a1.049,1.049,0,0,0,1.707.051L18,6.828', 'M0.750 11.999 A11.250 11.250 0 1 0 23.250 11.999 A11.250 11.250 0 1 0 0.750 11.999 Z']],
  CheckDouble: ['check-double', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.248,20.882,1.617,14.25A2.96,2.96,0,0,1,5.8,10.064l4.218,4.218,7.9-10.533A2.96,2.96,0,1,1,22.657,7.3L12.71,20.565A2.961,2.961,0,0,1,8.248,20.882Z']],
  CheckCircle: ['check-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.75,9l3.294,4.611a1.526,1.526,0,0,0,2.414.09L23.25.749', 'M16.783,3.824A10.487,10.487,0,1,0,20.8,8.377']],
  CheckSquare: ['check-square', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.75,9l3.294,4.611a1.526,1.526,0,0,0,2.414.09L23.25.749', 'M21.75,10.5v9.75a3,3,0,0,1-3,3h-15a3,3,0,0,1-3-3v-15a3,3,0,0,1,3-3H16.5']],
  CheckDouble1: ['check-double-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,4.249,11.808,19.505a1.5,1.5,0,0,1-2.261.161L6.57,16.689', 'M6,19.76a1.5,1.5,0,0,1-2.133.012L.89,16.8', 'M17.43 4.355L9.29 15.209']],
  RemoveCircle: ['remove-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 11.999 A11.250 11.250 0 1 0 23.250 11.999 A11.250 11.250 0 1 0 0.750 11.999 Z', 'M7.5 16.499L16.5 7.499', 'M16.5 16.499L7.5 7.499']],
  RemoveShield: ['remove-shield', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.5 14.999L16.5 5.999', 'M7.5 5.999L16.5 14.999', 'M3,.749a1.5,1.5,0,0,0-1.5,1.5v9c0,4.813,7.234,10.169,9.693,11.76a1.477,1.477,0,0,0,1.614,0c2.459-1.591,9.693-6.947,9.693-11.76v-9A1.5,1.5,0,0,0,21,.749Z']],
  CheckShield: ['check-shield', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.75,11.053,9.2,14.534a1.05,1.05,0,0,0,1.707.051L18.75,4.658', 'M3,.749a1.5,1.5,0,0,0-1.5,1.5v9c0,4.813,7.234,10.169,9.693,11.76a1.477,1.477,0,0,0,1.614,0c2.459-1.591,9.693-6.947,9.693-11.76v-9A1.5,1.5,0,0,0,21,.749Z']],
  Check1: ['check-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25.749,8.158,22.308a2.2,2.2,0,0,1-3.569.059L.75,17.249']],
  Check2: ['check-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6,13.223,8.45,16.7a1.049,1.049,0,0,0,1.707.051L18,6.828', 'M0.750 0.749 L23.250 0.749 L23.250 23.249 L0.750 23.249 Z']],
  CheckBadge: ['check-badge', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.75,9.749l-3.981,5.308a.75.75,0,0,1-1.13.08L8.25,12.749', 'M10.73,1.357a1.63,1.63,0,0,1,2.54,0l1.512,1.881a1.629,1.629,0,0,0,1.446.6l2.4-.261a1.63,1.63,0,0,1,1.8,1.8l-.261,2.4a1.629,1.629,0,0,0,.6,1.446l1.881,1.512a1.63,1.63,0,0,1,0,2.54L20.761,14.78a1.632,1.632,0,0,0-.6,1.447l.261,2.4a1.629,1.629,0,0,1-1.8,1.8l-2.4-.261a1.628,1.628,0,0,0-1.446.6L13.27,22.64a1.629,1.629,0,0,1-2.54,0L9.219,20.76a1.631,1.631,0,0,0-1.447-.6l-2.4.261a1.628,1.628,0,0,1-1.8-1.8l.261-2.4a1.631,1.631,0,0,0-.6-1.447l-1.88-1.511a1.629,1.629,0,0,1,0-2.54l1.88-1.512a1.628,1.628,0,0,0,.6-1.446l-.261-2.4a1.629,1.629,0,0,1,1.8-1.8l2.4.261a1.632,1.632,0,0,0,1.447-.6Z']],
  Close: ['close', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 23.249L23.25 0.749', 'M23.25 23.249L0.75 0.749']],
  CheckButton: ['check-button', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 5.249 L23.250 5.249 L23.250 18.749 L0.750 18.749 Z', 'M20.25 8.999L16.5 14.249 13.5 11.249']],
  RemoveBadge: ['remove-badge', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.73,1.357a1.63,1.63,0,0,1,2.54,0l1.512,1.881a1.629,1.629,0,0,0,1.446.6l2.4-.261a1.63,1.63,0,0,1,1.8,1.8l-.261,2.4a1.629,1.629,0,0,0,.6,1.446l1.881,1.512a1.63,1.63,0,0,1,0,2.54L20.761,14.78a1.632,1.632,0,0,0-.6,1.447l.261,2.4a1.629,1.629,0,0,1-1.8,1.8l-2.4-.261a1.628,1.628,0,0,0-1.446.6L13.27,22.64a1.629,1.629,0,0,1-2.54,0L9.219,20.76a1.631,1.631,0,0,0-1.447-.6l-2.4.261a1.628,1.628,0,0,1-1.8-1.8l.261-2.4a1.631,1.631,0,0,0-.6-1.447l-1.88-1.511a1.629,1.629,0,0,1,0-2.54l1.88-1.512a1.628,1.628,0,0,0,.6-1.446l-.261-2.4a1.629,1.629,0,0,1,1.8-1.8l2.4.261a1.632,1.632,0,0,0,1.447-.6Z', 'M9 14.999L15 8.999', 'M9 8.999L15 14.999']],
  RemoveButton: ['remove-button', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 5.249 L23.250 5.249 L23.250 18.749 L0.750 18.749 Z', 'M15 9.374L20.25 14.624', 'M15 14.624L20.25 9.374']],
  RemoveSquare: ['remove-square', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.749 L23.250 0.749 L23.250 23.249 L0.750 23.249 Z', 'M7.5 16.499L16.5 7.499', 'M16.5 16.499L7.5 7.499']],
  CursorChoose: ['cursor-choose', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6,23.249,4.1,19.923a2.263,2.263,0,0,1,3.848-2.378l1.8,2.7V9a2.25,2.25,0,1,1,4.5,0v8.25h3.379A4.332,4.332,0,0,1,21.75,21.6v1.653', 'M18 0.749L23.25 5.999', 'M18 5.999L23.25 0.749', 'M7.5 0.749L3.75 5.999 0.75 2.999']]
};
exports["default"] = _default;